"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEmptyQuotationCoverage = void 0;
function makeEmptyQuotationCoverage() {
    return {
        coverageId: '',
        priceModel: '',
        rate: 0,
        price: 0,
        deductible: 0,
        insuredValue: 0,
        allowDiscount: false,
        coreBranch: '',
        deductibleRate: 10,
        deductibleDescription: '',
    };
}
exports.makeEmptyQuotationCoverage = makeEmptyQuotationCoverage;
//# sourceMappingURL=QuotationCoverage.js.map